enum EnumPeriodForAnalytic {
	OneSecond = 1000,
	OneMinute = 60000,
	TenMinutes = 600000,
	ThirtyMinutes = 1800000,
	OneHour = 3600000
}
export default EnumPeriodForAnalytic
